import { render, staticRenderFns } from "./BracketFightNumberDraw.vue?vue&type=template&id=5460cd9e&scoped=true&"
import script from "./BracketFightNumberDraw.vue?vue&type=script&lang=js&"
export * from "./BracketFightNumberDraw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5460cd9e",
  null
  
)

export default component.exports